<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :fill="fill"
       :width="size"
       :height="size"
       class="rotatable-svg"
       :class="{rotate: rotate}"
       viewBox="0 0 16 16">
    <path fill-rule="evenodd"
          d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
  </svg>
</template>

<script>
export default {
  name: "ChevronDownIcon",
  props: {
    fill: {
      type: String,
      default: 'currentColor'
    },
    size: {
      type: [String, Number],
      default: 16
    },
    rotate: {
      type: Boolean,
      default: false
    }
  }
}
</script>
